import { gql } from '@apollo/client'

export const CREATE_VEHICLE_MUTATION = gql`
  mutation CreateVehicle($input: CreateAndUpdateVehicleDtoInput!) {
    createVehicle(input: $input) {
      id
      driverId
      registrationNumber
      vehicleTypeId
      manufacturer
      dateOfManufacture
      model
      colour
      insuranceCompany
      insuranceExpiryDate
      motTestExpiryDate
      isRenewalReminder
      policyOrCoverNote
      goodsInTransitExpiryDate
      vehicleType {
        id
        name
      }
    }
  }
`

export const UPDATE_VEHICLE_MUTATION = gql`
  mutation UpdateVehicle($input: CreateAndUpdateVehicleDtoInput!) {
    updateVehicle(input: $input) {
      id
      driverId
      registrationNumber
      vehicleTypeId
      manufacturer
      dateOfManufacture
      model
      colour
      insuranceCompany
      insuranceExpiryDate
      motTestExpiryDate
      isRenewalReminder
      policyOrCoverNote
      goodsInTransitExpiryDate
      vehicleType {
        id
        name
      }
    }
  }
`

export const DELETE_VEHICLE_MUTATION = gql`
  mutation DeleteVehicle($vehicleId: ID!) {
    deleteVehicle(id: $vehicleId)
  }
`
